import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=5e8d7e28&"
import script from "./x-icon.vue?vue&type=script&lang=ts&"
export * from "./x-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports